module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ls1DE3/tc-custom/9798889109426.jpg?1718078506184",
      "alt": "This image is the cover for the book Schoolhouse Burning"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Schoolhouse Burning\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Dive into "), _c('em', [_vm._v("Schoolhouse Burning")]), _vm._v(" for a transformative journey through the lens of Rodger, an expert in Alternative Dispute Resolution and Mediation. With a rich background that began in the helping professions at a state school and regional hospital, Rodger offers a unique perspective on conflicts and disputes that have troubled humanity for ages. Drawing from his extensive experience, including his Master of Science degree in Counseling Psychology and his unwavering belief in a Higher Power, he provides insights that promise to enlighten readers on both personal and civilizational levels.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Rodger was motivated to write this book by the belief that all the remedies for what ails mankind will be found in the earth, the study of the past, and the divine word of the Lord, regardless of the culture and their people to whom He has revealed Himself.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Each chapter of this book delves into issues that resonate both internally and externally, offering readers the chance to select topics that resonate most with them. Beyond his professional expertise, get to know Rodger as a lover of the outdoors, music, classic novels, and the simple pleasure of a warm campfire. His life’s philosophy? Use your strengths responsibly, without infringing on the rights of others. Join him in this exploration and discover ways to responsibly navigate the challenges of life.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rodger B. Moore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0mm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Rodger B. Moore is a single white male, divorced/widower, with no children. He is a retired counselor with a Masters in Counseling Psychology and over 40 years of post-Masters experience in the mental health field and human support services. He recently semi-retired due to increased demand for services. He enjoys hiking, chess, swimming, and dancing. He does not consume alcohol or tobacco. He has a ‘have plan, will travel’ attitude and is an ideas-driven person with a ‘helping’ orientation. He expanded his practice to include mediation services. He has never been convicted of a felony, is up-to-date on all vaccinations, has never been sued for malpractice, and has never lost a client to suicide.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0